<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Company Billing Info</h4>
            <div class="row mt-4 justify-content-center">
              <div class="col-lg-7">
                <div class="row">
                  <div class="col-lg-6 mt-4">
                    <div>
                      <label>Company Name</label>
                      <b-form-input
                        for="text"
                        placeholder="Company Name"
                        v-model="billingInfo.companyName"
                        :class="{
                          'is-invalid': billingInfo_errors.companyNameError,
                        }"
                      ></b-form-input>
                      <div
                        v-if="billingInfo_errors.companyNameError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.companyNameMessage }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 mt-4">
                    <div>
                      <label>Address</label>
                      <b-form-input
                        for="text"
                        placeholder="Address"
                        v-model="billingInfo.address"
                        :class="{
                          'is-invalid': billingInfo_errors.addressError,
                        }"
                      ></b-form-input>
                      <div
                        v-if="billingInfo_errors.addressError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.addressMessage }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 mt-4">
                    <div>
                      <label>City</label>
                      <b-form-input
                        for="text"
                        placeholder="City"
                        v-model="billingInfo.city"
                        :class="{ 'is-invalid': billingInfo_errors.cityError }"
                      ></b-form-input>
                      <div
                        v-if="billingInfo_errors.cityError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.cityMessage }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-4">
                    <div>
                      <label>Postal Code</label>
                      <b-form-input
                        for="text"
                        placeholder="Postal Code"
                        v-model="billingInfo.postal"
                        :class="{
                          'is-invalid': billingInfo_errors.postalError,
                        }"
                        :maxlength="6"
                      ></b-form-input>
                      <div
                        v-if="billingInfo_errors.postalError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.postalMessage }}</span>
                      </div>
                      <div v-if="billingInfo.postal" class="text-center">
                        <p
                          class="badge position-absolute mt-1"
                          :class="{
                            'badge-danger': billingInfo.postal.length !== 6,
                            'badge-success': billingInfo.postal.length === 6,
                          }"
                        >
                          {{ billingInfo.postal.length }} / 6
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-4">
                    <div>
                      <label>Province</label>
                      <v-select
                        :options="provinces"
                        v-model="billingInfo.province"
                        label="name"
                        :class="{
                          'is-invalid ddl-is-invalid':
                            billingInfo_errors.provinceError,
                        }"
                      ></v-select>
                      <div
                        v-if="billingInfo_errors.provinceError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.provinceMessage }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-4">
                    <div>
                      <label>Country</label>
                      <b-form-input
                        for="text"
                        placeholder="Country"
                        value="Canada"
                        disabled
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-4">
                    <div>
                      <label>Email</label>
                      <b-form-input
                        for="text"
                        placeholder="Email"
                        v-model="billingInfo.email"
                        :class="{ 'is-invalid': billingInfo_errors.emailError }"
                      ></b-form-input>
                      <div
                        v-if="billingInfo_errors.emailError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.emailMessage }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-4">
                    <div>
                      <label>Phone</label>
                      <b-form-input
                        for="text"
                        placeholder="Phone"
                        v-model="billingInfo.phone"
                        :class="{ 'is-invalid': billingInfo_errors.phoneError }"
                        @keypress="checkNumerical($event)"
                        @input="acceptNumber()"
                        :maxlength="14"
                      ></b-form-input>
                      <div v-if="billingInfo.phone" class="text-center">
                        <p
                          class="badge position-absolute mt-1"
                          :class="{
                            'badge-danger': billingInfo.phone.length !== 14,
                            'badge-success': billingInfo.phone.length === 14,
                          }"
                        >
                          {{ billingInfo.phone.length }} / 14
                        </p>
                      </div>
                      <div
                        v-if="billingInfo_errors.phoneError"
                        class="invalid-feedback"
                      >
                        <span>{{ billingInfo_errors.phoneMessage }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3 mb-4 float-right">
                  <div class="col-12">
                    <b-button
                      id="btn_search"
                      variant="primary"
                      v-on:click="submitBillingInfoEdit()"
                      >Update</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Page Settings</h4>
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active" @click="selectedPageSettingTab = 'Work Orders'">Work Orders</a>
              </li>
            </ul>
            <div v-if="selectedPageSettingTab === 'Work Orders'" class="row">
              <div class="col-lg-4">
                <div class="row">
                  <div class="col-lg-12 ml-5 mt-3 mb-3">
                    <div class="row mt-4">
                      <div class="col-9">
                        <div class="form-group">
                          <label class="font-weight-bold" id="lbl_settings_newIssue" >New Issue Submitted Notification <i class="bx bxs-help-circle"></i><b-tooltip target="lbl_settings_newIssue" triggers="hover">
                            If enabled, an email will be sent whenever a New Issue is submitted.
                          </b-tooltip></label>
                          <br />
                          <switches
                            text-enabled="Enabled"
                            text-disabled="Disabled"
                            v-model="switch_newIssueEmailSetting"
                            type-bold="false"
                            color="primary"
                          ></switches>

                          <div>
                            <div class="mb-3">
                              <label class="font-weight-bold" id="lbl_settings_newIssue_userType" >User Type <i class="bx bxs-help-circle"></i><b-tooltip target="lbl_settings_newIssue_userType" triggers="hover">
                                Select which type of users that submit a new issue will trigger the notification. Select one or multiple.
                              </b-tooltip></label>
                              <v-select
                                :options="newIssueNotiUserTypeOptions"
                                v-model="selectedNewIssueNotiUserTypeOption"
                                @input="handleNewIssueNotiUserTypeSelection"
                                label="option"
                                multiple
                                small-chips 
                                class="user-type-select"
                              ></v-select>
                            </div>
                          </div>
      
                          <div>
                            <div class="mb-3">
                              <label>Recipient Email(s)</label>
                              <v-select
                                :options="newIssueNotiEmailOptions"
                                v-model="selectedNewIssueNotiEmailOption"
                                label="option"
                              ></v-select>
                            </div>
                            <div v-if="selectedNewIssueNotiEmailOption.index === 1">
                              <div v-for="(
                                  email, index
                                ) in workOrderPageSettings.newIssueNotificationEmails" :key="index" class="d-flex">
                                <div class="d-flex mb-1 align-items-center removeEmailInput">
                                  <i @click="
                                      handleRemoveNotificationEmailInput(
                                        'newIssueNotificationEmails',
                                        index,
                                        'newIssueNotificationEmailErrorMessage'
                                      )
                                    " class="bx bx-x"></i>
                                </div>
                                <b-form-input v-model="workOrderPageSettings.newIssueNotificationEmails[index]" type="email"
                                  placeholder="Enter an e-mail" :class="{
                                    'is-invalid':
                                    workOrderPageSettingsErrors.newIssueNotificationEmailErrorMessage.find(
                                        (x) => x.index === index
                                      ),
                                    'mb-1': true,
                                  }" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"></b-form-input>
                              </div>
                              <div class="mb-4 mt-2 mx-auto d-flex addEmailInput">
                                <i @click="handleAddNotificationEmailInput('newIssueNotificationEmails')" class="bx bx-plus"></i>
                                <p @click="handleAddNotificationEmailInput('newIssueNotificationEmails')">
                                  {{ workOrderPageSettings.newIssueNotificationEmails.length === 0
                                    ? 'Add Email'
                                    : 'Add Another Email' }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="row">
                  <div class="col-lg-12 ml-5 mt-3 mb-3">
                    <div class="row mt-4">
                      <div class="col-9">
                        <div class="form-group">
                          <label class="font-weight-bold" id="lbl_settings_requestedChangesEmail" >Work Order Requested Changes Notification <i class="bx bxs-help-circle"></i><b-tooltip target="lbl_settings_requestedChangesEmail" triggers="hover">
                            If enabled, an email will be sent whenever changes are requested for a submitted work order.
                          </b-tooltip></label>
                          <br />
                          <switches
                            text-enabled="Enabled"
                            text-disabled="Disabled"
                            v-model="switch_workOrderRequestedChangesSetting"
                            type-bold="false"
                            color="primary"
                          ></switches>
      
                          <div>
                            <div class="mb-3">
                              <label>Recipient Email(s)</label>
                              <v-select
                                :options="requestedChangesNotiEmailOptions"
                                v-model="selectedRequestedChangesNotiEmailOption"
                                label="option"
                              ></v-select>

                            </div>
                            <div v-if="selectedRequestedChangesNotiEmailOption.index === 1">
                              <div v-for="(
                                  email, index
                                ) in workOrderPageSettings.requestedChangesNotificationEmails" :key="index" class="d-flex">
                                <div class="d-flex mb-1 align-items-center removeEmailInput">
                                  <i @click="
                                      handleRemoveNotificationEmailInput(
                                        'requestedChangesNotificationEmails',
                                        index,
                                        'requestedChangesNotificationEmailErrorMessage'
                                      )
                                    " class="bx bx-x"></i>
                                </div>
                                <b-form-input v-model="workOrderPageSettings.requestedChangesNotificationEmails[index]" type="email"
                                  placeholder="Enter an e-mail" :class="{
                                    'is-invalid':
                                    workOrderPageSettingsErrors.requestedChangesNotificationEmailErrorMessage.find(
                                        (x) => x.index === index
                                      ),
                                    'mb-1': true,
                                  }" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"></b-form-input>
                              </div>
                              <div class="mb-4 mt-2 mx-auto d-flex addEmailInput">
                                <i @click="handleAddNotificationEmailInput('requestedChangesNotificationEmails')" class="bx bx-plus"></i>
                                <p @click="handleAddNotificationEmailInput('requestedChangesNotificationEmails')">
                                  {{ workOrderPageSettings.requestedChangesNotificationEmails.length === 0
                                    ? 'Add Email'
                                    : 'Add Another Email' }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="row">
                  <div class="col-lg-12 ml-5 mt-3 mb-3">
                    <div class="row mt-4">
                      <div class="col-9">
                        <div class="form-group">
                          <label class="font-weight-bold" id="lbl_settings_workOrderApprovalEmail">Work Order Submitted for Approval Notification <i class="bx bxs-help-circle"></i><b-tooltip target="lbl_settings_workOrderApprovalEmail" triggers="hover">
                            If enabled, an email will be sent whenever a work order is submitted for approval.
                          </b-tooltip></label>
                          <br />
                          <switches
                            text-enabled="Enabled"
                            text-disabled="Disabled"
                            v-model="switch_workOrderApprovalEmailSetting"
                            type-bold="false"
                            color="primary"
                          ></switches>
      
                          <div>
                            <label>Recipient Email(s)</label>
                            <div v-for="(
                                email, index
                              ) in workOrderPageSettings.submittedForApprovalNotificationEmails" :key="index" class="d-flex">
                              <div class="d-flex mb-1 align-items-center removeEmailInput">
                                <i @click="
                                    handleRemoveNotificationEmailInput(
                                      'submittedForApprovalNotificationEmails',
                                      index,
                                      'submittedForApprovalNotificationEmailErrorMessage'
                                    )
                                  " class="bx bx-x"></i>
                              </div>
                              <b-form-input v-model="workOrderPageSettings.submittedForApprovalNotificationEmails[index]" type="email"
                                placeholder="Enter an e-mail" :class="{
                                  'is-invalid':
                                  workOrderPageSettingsErrors.submittedForApprovalNotificationEmailErrorMessage.find(
                                      (x) => x.index === index
                                    ),
                                  'mb-1': true,
                                }" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"></b-form-input>
                            </div>
                            <div class="mb-4 mt-2 mx-auto d-flex addEmailInput">
                              <i @click="handleAddNotificationEmailInput('submittedForApprovalNotificationEmails')" class="bx bx-plus"></i>
                              <p @click="handleAddNotificationEmailInput('submittedForApprovalNotificationEmails')">
                                {{ workOrderPageSettings.submittedForApprovalNotificationEmails.length === 0
                                  ? 'Add Email'
                                  : 'Add Another Email' }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            </div>
            <div class="row mt-4 justify-content-center">
              <div class="col-lg-12 d-flex justify-content-center">
                <b-button
                  id="btn_updateWorkOrderApprovalEmail"
                  class="mt-4 d-flex justify-content-center"
                  variant="primary"
                  style="width: 9rem;"
                  v-on:click="UpdateWorkOrderPageSettings()"
                >
                  <spring-spinner
                    class="label-spinner"
                    v-if="loadingWorkOrderPageSettingsUpdate"
                    :animation-duration="3000"
                    :size="20"
                    color="white"
                  />
                  <span v-else>Update Settings</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="'comingSoon'" class="col-lg-4">
        <div class="card">
          <div class="row">
            <div class="col-lg-12 ml-5 mt-3 mb-3">
              <div class="row mt-4">
                <div class="col-6">
                  <div class="form-group">
                    <label>Sage50</label>
                    <br />
                    <switches
                      disabled
                      text-enabled="Enabled"
                      text-disabled="disabled"
                      v-model="switch_sageIntegration"
                      type-bold="false"
                      color="primary"
                      class="ml-1 mb-0"
                    ></switches>
                  </div>
                </div>
                <div class="col-5 float-right">
                  <div class="form-group float-right mr-5">
                    <b-button
                      v-if="switch_sageIntegration"
                      v-on:click="disableIntegration('sage')"
                      variant="primary"
                      class="btn btn-label btn-danger"
                      ><i class="bx bx-x label-icon"></i>Disable</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="row mt-3 mb-4">
                <div class="col-12">
                  <b-button
                    v-if="switch_sageIntegration"
                    variant="primary"
                    v-on:click="sageIntegration()"
                    class="btn btn-label btn-primary"
                    ><i class="bx bx-sync label-icon"></i>Refresh</b-button
                  >
                  <b-button
                    v-b-modal.configure-sage
                    variant="primary"
                    class="ml-2"
                    >{{
                      switch_sageIntegration ? 'Configure' : 'Setup'
                    }}
                    Integration</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div
          :class="
            integrationsAuthorized.quick_books == 'true' ? null : 'comingSoon'
          "
          class="card"
        >
          <div class="row">
            <div class="col-lg-12 ml-5 mt-3 mb-3">
              <div class="row mt-4">
                <div class="col-6">
                  <div class="form-group">
                    <label>QuickBooks Online</label>
                    <br />
                    <switches
                      disabled
                      text-enabled="Enabled"
                      text-disabled="disabled"
                      v-model="switch_qbIntegration"
                      type-bold="false"
                      color="primary"
                      class="ml-1 mb-0"
                    ></switches>
                  </div>
                </div>
                <div class="col-5 float-right">
                  <div class="form-group float-right mr-5">
                    <b-button
                      v-if="switch_qbIntegration"
                      v-on:click="disableIntegration('quick_books')"
                      variant="primary"
                      class="btn btn-label btn-danger"
                      ><i class="bx bx-x label-icon"></i>Disable</b-button
                    >
                  </div>
                </div>
              </div>
              <div v-if="qbIntegrationSetup.invoices" class="row">
                <div class="mt-3 mb-3">
                  <div class="col-12">
                    <label>Default Income Account For Invoicing:</label>
                    <h5>{{ qbIntegrationSetup.defaultAccount.name }}</h5>
                  </div>
                </div>
              </div>
              <div class="row mt-3 mb-4">
                <div class="col-12">
                  <b-button
                    v-if="switch_qbIntegration"
                    variant="success"
                    v-on:click="qbIntegration()"
                    class="btn btn-label btn-primary"
                    ><i class="bx bx-sync label-icon"></i>Refresh
                    Credentials</b-button
                  >
                  <br />
                  <b-button
                    v-b-modal.configure-qbo
                    variant="primary"
                    class="mt-2"
                    >{{
                      switch_qbIntegration ? 'Configure' : 'Setup'
                    }}
                    Integration</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div
          :class="integrationsAuthorized.tikker == 'true' ? null : 'comingSoon'"
          class="card"
        >
          <div class="row">
            <div class="col-lg-12 ml-5 mt-3 mb-3">
              <div class="row mt-4">
                <div class="col-12">
                  <div class="form-group">
                    <label>Tikker</label>
                    <br />
                    <switches
                      text-enabled="Enabled"
                      text-disabled="disabled"
                      type-bold="false"
                      color="primary"
                      class="ml-1 mb-0"
                    ></switches>
                  </div>
                </div>
              </div>
              <div class="row mt-3 mb-4">
                <div class="col-12">
                  <b-button
                    v-if="false"
                    variant="primary"
                    v-on:click="sageIntegration()"
                    class="btn btn-label btn-primary"
                    ><i class="bx bx-sync label-icon"></i>Refresh</b-button
                  >
                  <b-button variant="primary" class="ml-2"
                    >{{ false ? 'Configure' : 'Setup' }} Integration</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sage integration setup modal -->
    <b-modal
      id="configure-sage"
      centered
      title="Configure Sage50 Integration"
      title-class="font-18"
      hide-footer
      ref="sage_integration_modal"
    >
      <form-wizard
        color="#556ee6"
        @on-complete="sageIntegrationSubmit()"
        :start-index="0"
      >
        <tab-content icon="bx bx-user-circle">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-4">
              <h2>Do you want to sync your customers with Kali?</h2>
              <switches
                text-enabled="Yes"
                text-disabled="No"
                v-model="sageIntegrationSetup.customers"
                type-bold="false"
                color="primary"
                class="integrationSwitch mt-4 mb-4"
              ></switches>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>
        <tab-content icon="bx bx-money">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-4">
              <h2>Do you want to import invoices into Sage from Kali?</h2>
              <switches
                text-enabled="Yes"
                text-disabled="No"
                v-model="sageIntegrationSetup.invoices"
                type-bold="false"
                color="primary"
                class="integrationSwitch mt-4 mb-4"
              ></switches>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>
        <tab-content icon="bx bx-hive">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-4">
              <h2>Do you want to view your Sage inventory in Kali?</h2>
              <switches
                text-enabled="Yes"
                text-disabled="No"
                v-model="sageIntegrationSetup.inventory"
                type-bold="false"
                color="primary"
                class="integrationSwitch mt-4 mb-4"
              ></switches>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>
        <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-5">
              <h2>
                <i class="mdi mdi-check-all"></i>
              </h2>
              <h2>Setup complete, click finish to submit changes.</h2>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>
      </form-wizard>
    </b-modal>
    <!-- /modal -->

    <!-- QBO Integration Setup Modal -->
    <b-modal
      id="configure-qbo"
      centered
      title="Configure QuickBooks Online Integration"
      title-class="font-18"
      hide-footer
      ref="qbo_integration_modal"
    >
      <form-wizard
        color="#556ee6"
        @on-complete="qboIntegrationSubmit()"
        :start-index="0"
      >
        <tab-content icon="bx bx-user-circle">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-4">
              <h2>Do you want to sync your customers with Kali?</h2>
              <switches
                text-enabled="Yes"
                text-disabled="No"
                v-model="qbIntegrationSetup.customers"
                type-bold="false"
                color="primary"
                class="integrationSwitch mt-4 mb-4"
              ></switches>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>
        <tab-content icon="bx bx-money">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-4">
              <h2>
                Do you want to import invoices into QuickBook Online from Kali?
              </h2>
              <switches
                text-enabled="Yes"
                text-disabled="No"
                v-model="qbIntegrationSetup.invoices"
                type-bold="false"
                color="primary"
                class="integrationSwitch mt-4 mb-4"
              ></switches>
            </div>
            <!-- end col -->
          </div>
          <div v-if="qbIntegrationSetup.invoices" class="row">
            <div class="col-12 mb-5 text-center">
              <h4>Default Income Account For Invoicing</h4>
              <v-select
                :options="qbIntegrationSetup.accounts"
                v-model="qbIntegrationSetup.defaultAccount"
                label="name"
              ></v-select>
            </div>
          </div>
          <!-- end row -->
        </tab-content>
        <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
          <div class="row">
            <div class="col-12 text-center mt-4 mb-5">
              <h2>
                <i class="mdi mdi-check-all"></i>
              </h2>
              <h2>Setup complete, click finish to submit changes.</h2>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>
      </form-wizard>
    </b-modal>
    <!-- /modal -->
  </div>
</template>

<script>
import Vue from 'vue';
import Swal from 'sweetalert2';
import Switches from 'vue-switches';
import { FormWizard, TabContent } from 'vue-form-wizard';
import axios from 'axios';
import lodash from 'lodash';
import { SpringSpinner } from 'epic-spinners';
import VueToast from 'vue-toast-notification';
import { getPositions } from '../../helper/dbHelpers.js';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

import firebase from 'firebase';
// import moment from 'moment';

import {
  getCompanyBillingInfo,
  validateEmail,
  updateSageIntegrationDetails,
  getQBIncomeAccounts,
  updateQBOIntegrationDetails,
} from '../../helper/dbHelpers.js';
import { parseBoolFromString } from '../../helper/helpers.js';
import { customStateMethods } from '@/state/helpers';

export default {
  components: {
    Switches,
    FormWizard,
    TabContent,
    SpringSpinner,
  },
  data() {
    return {
      name: 'searchJobsComponent',
      billingInfo: {
        companyName: null,
        address: null,
        city: null,
        province: null,
        postal: null,
        email: null,
        phone: null,
      },
      billingInfo_errors: {
        companyNameError: null,
        companyNameMessage: null,
        addressError: null,
        addressMessage: null,
        cityError: null,
        cityMessage: null,
        provinceError: null,
        provinceMessage: null,
        postalError: null,
        postalMessage: null,
        emailError: null,
        emailMessage: null,
        phoneError: null,
        phoneMessage: null,
      },
      provinces: [
        {
          name: 'Alberta',
          abbreviation: 'AB',
        },
        {
          name: 'British Columbia',
          abbreviation: 'BC',
        },
        {
          name: 'Manitoba',
          abbreviation: 'MB',
        },
        {
          name: 'New Brunswick',
          abbreviation: 'NB',
        },
        {
          name: 'Newfoundland and Labrador',
          abbreviation: 'NL',
        },
        {
          name: 'Northwest Territories',
          abbreviation: 'NT',
        },
        {
          name: 'Nova Scotia',
          abbreviation: 'NS',
        },
        {
          name: 'Nunavut',
          abbreviation: 'NU',
        },
        {
          name: 'Ontario',
          abbreviation: 'ON',
        },
        {
          name: 'Prince Edward Island',
          abbreviation: 'PE',
        },
        {
          name: 'Quebec',
          abbreviation: 'QC',
        },
        {
          name: 'Saskatchewan',
          abbreviation: 'SK',
        },
        {
          name: 'Yukon Territory',
          abbreviation: 'YT',
        },
      ],
      switch_sageIntegration: false,
      switch_qbIntegration: false,
      sageIntegrationSetup: {
        invoices: false,
        inventory: false,
        customers: false,
      },
      qbIntegrationSetup: {
        invoices: false,
        customers: false,
        accounts: [],
        defaultAccount: {
          name: null,
          id: null,
          sync_token: null,
        },
      },
      switch_workOrderRequestedChangesSetting: false,
      settingsDocId: null,
      switch_workOrderApprovalEmailSetting: false,
      switch_newIssueEmailSetting: false,
      workOrderApprovalEmail: null,
      workOrderApprovalEmail_errors: {
        workOrderApprovalEmailError: null,
        workOrderApprovalEmailMessage: null,
      },
      selectedPageSettingTab: 'Work Orders',
      workOrderPageSettings: {
        newIssueNotificationEmails: [],
        requestedChangesNotificationEmails: [],
        submittedForApprovalNotificationEmails: [],
      },
      workOrderPageSettingsErrors: {
        newIssueNotificationEmailErrorMessage: [],
        requestedChangesNotificationEmailErrorMessage: [],
        submittedForApprovalNotificationEmailErrorMessage: [],
      },
      orgSettings: null,
      loadingWorkOrderPageSettingsUpdate: false,
      requestedChangesNotiEmailOptions: [
        {option: 'Employee that Submitted the Work Order', index: 0},
        {option: 'Custom Email(s)', index: 1},
      ],
      selectedRequestedChangesNotiEmailOption: {option: 'Employee that Submitted the Work Order'},
      newIssueNotiEmailOptions: [
        {option: 'All Mechanic Users', index: 0},
        {option: 'Custom Email(s)', index: 1},
      ],
      newIssueNotiUserTypeOptions: [
        {option: 'All User Types', index: 0}
      ],
      selectedNewIssueNotiEmailOption: {option: 'All Mechanic Users'},
      selectedNewIssueNotiUserTypeOption: [{option: 'All User Types', index: 0}],
      previouslySelectedNotiUserTypeOption: [{option: 'All User Types', index: 0}],
    };
  },
  methods: {
    ...customStateMethods,
    getBillingInfo: function() {
      getCompanyBillingInfo()
        .then((info) => {
          let billingInfo = info.data().billingInfo;
          //start populating the company info.
          this.billingInfo = {
            companyName: billingInfo.name != undefined ? billingInfo.name : '',
            address:
              billingInfo.address != undefined ? billingInfo.address : '',
            city: billingInfo.city != undefined ? billingInfo.city : '',
            province:
              billingInfo.province != undefined ? billingInfo.province : '',
            country:
              billingInfo.country != undefined ? billingInfo.country : '',
            postal:
              billingInfo.postalCode != undefined ? billingInfo.postalCode : '',
            email: billingInfo.email != undefined ? billingInfo.email : '',
            phone: billingInfo.phone != undefined ? billingInfo.phone : '',
          };
        })
        .catch(() => {
          Swal.fire('Error!', 'Error getting the company settings.', 'error');
        });
    },
    validateBillingInfoEdit: function() {
      //check to make sure nothing that is required is blank and that the regexs are met.
      let flag = true;
      var postalCodeRegex = new RegExp(
        /([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i
      );

      if (
        this.billingInfo.companyName === null ||
        this.billingInfo.companyName === undefined ||
        this.billingInfo.companyName.toString().trim() == ''
      ) {
        this.billingInfo_errors.companyNameError = true;
        this.billingInfo_errors.companyNameMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.billingInfo_errors.companyNameError = false;
        this.billingInfo_errors.companyNameMessage = null;
      }

      if (
        this.billingInfo.address === null ||
        this.billingInfo.address === undefined ||
        this.billingInfo.address.toString().trim() == ''
      ) {
        this.billingInfo_errors.addressError = true;
        this.billingInfo_errors.addressMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.billingInfo_errors.addressError = false;
        this.billingInfo_errors.addressMessage = null;
      }

      if (
        this.billingInfo.city === null ||
        this.billingInfo.city === undefined ||
        this.billingInfo.city.toString().trim() == ''
      ) {
        this.billingInfo_errors.cityError = true;
        this.billingInfo_errors.cityMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.billingInfo_errors.cityError = false;
        this.billingInfo_errors.cityMessage = null;
      }

      //check to make sure the postal code isn't empty and is formatted correctly.
      if (
        this.billingInfo.postal === null ||
        this.billingInfo.postal === undefined ||
        this.billingInfo.postal.toString().trim() == ''
      ) {
        this.billingInfo_errors.postalError = true;
        this.billingInfo_errors.postalMessage = 'Value cannot be empty.';
        flag = false;
      } else if (
        !postalCodeRegex.test(
          this.billingInfo.postal.trim().replace(/\W+/g, '')
        )
      ) {
        //check to see if the format is correct.
        this.billingInfo_errors.postalError = true;
        this.billingInfo_errors.postalMessage =
          'Postal code is not formatted correctly, eg: T7V 2G3';
        flag = false;
      } else {
        this.billingInfo_errors.postalError = false;
        this.billingInfo_errors.postalMessage = null;
      }

      if (
        this.billingInfo.province === null ||
        this.billingInfo.province === undefined ||
        this.billingInfo.province.toString().trim() == ''
      ) {
        this.billingInfo_errors.provinceError = true;
        this.billingInfo_errors.provinceMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.billingInfo_errors.provinceError = false;
        this.billingInfo_errors.provinceMessage = null;
      }

      //make surte the email isn't empty and is in a vlaid format.
      if (
        this.billingInfo.email === null ||
        this.billingInfo.email === undefined ||
        this.billingInfo.email.toString().trim() == ''
      ) {
        this.billingInfo_errors.emailError = true;
        this.billingInfo_errors.emailMessage = 'Value cannot be empty.';
        flag = false;
      } else if (validateEmail(this.billingInfo.email.trim())) {
        this.billingInfo_errors.emailError = false;
        this.billingInfo_errors.emailMessage = null;
      } else {
        this.billingInfo_errors.emailError = true;
        this.billingInfo_errors.emailMessage = 'Value is not a valid email.';
        flag = false;
      }

      if (
        this.billingInfo.phone === null ||
        this.billingInfo.phone === undefined ||
        this.billingInfo.phone.toString().trim() == ''
      ) {
        this.billingInfo_errors.phoneError = true;
        this.billingInfo_errors.phoneMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.billingInfo_errors.phoneError = false;
        this.billingInfo_errors.phoneMessage = null;
      }

      return flag;
    },
    submitBillingInfoEdit: function() {
      if (this.validateBillingInfoEdit() == true) {
        firebase
          .firestore()
          .collection('organizations')
          .doc(sessionStorage.getItem('org'))
          .update({
            billingInfo: {
              name: this.billingInfo.companyName,
              address: this.billingInfo.address,
              city: this.billingInfo.city,
              postalCode: this.billingInfo.postal,
              province: this.billingInfo.province,
              email: this.billingInfo.email,
              phone: this.billingInfo.phone,
            },
          })
          .then(() => {
            Swal.fire(
              'Success!',
              'Billing info updated successfully.',
              'success'
            );
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'Error updating the company settings.',
              'error'
            );
          });
      }
    },
    acceptNumber() {
      var x = this.billingInfo.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.billingInfo.phone = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    checkNumerical: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sageIntegration: function() {
      //send the user to the moooooon.
      //production, redirect is the live uri.
      // window.location.href = 'https://www.sageone.com/oauth2/auth/central?filter=apiv3.1&client_id=494a145b-97a2-4fb7-ae7b-9315165524f3/6f21ca1b-2e7b-45ae-974f-edde0926f747&redirect_uri=https://ce-solutions.ca/kali/api/inventoryTest&country=ca&locale=en-CA&response_type=code';
      //testing; the redirect uri is localhost.
      window.location.href =
        'https://www.sageone.com/oauth2/auth/central?filter=apiv3.1&client_id=494a145b-97a2-4fb7-ae7b-9315165524f3/6f21ca1b-2e7b-45ae-974f-edde0926f747&redirect_uri=http://localhost:8080/production/admin/settingsContainer&country=ca&locale=en-CA&response_type=code';
    },
    checkOAuthQueryString: function() {
      //check to see if we have the sage 50 integration code.
      const urlParams = new URLSearchParams(window.location.search);
      const oAuthCode = urlParams.get('code');
      if (oAuthCode != null) {
        //exchange the code for an access token.
        let sendParams = {
          code: `${oAuthCode}`,
        };
        if (sessionStorage.getItem('sage_active') == 'true') {
          //axios.get(`http://localhost:5000/kali-45420/us-central1/getSageToken`, {
          axios
            .get(
              `https://us-central1-kali-45420.cloudfunctions.net/getSageToken`,
              {
                params: {
                  sendParams,
                },
              }
            )
            .then((response) => {
              //update the access and refresh token in the db.
              updateSageIntegrationDetails(
                response.data.response.access_token,
                response.data.response.refresh_token,
                sessionStorage.getItem('sage_invoicing'),
                sessionStorage.getItem('sage_customers'),
                sessionStorage.getItem('sage_inventory')
              );
              Swal.fire(
                'Success!',
                'Sage account successfully integrated.',
                'success'
              );
              this.switch_sageIntegration = true;
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                'Error!',
                'Error setting up Sage Integration.',
                'error'
              );
            });
        } else if (sessionStorage.getItem('qb_active') == 'true') {
          //if the integration being setup is qb, then we also need the realm ID.
          const realmId = urlParams.get('realmId');
          let sendParams = {
            url: `${window.location.href}`,
            org: sessionStorage.getItem('org'),
            realmId: realmId,
            customers: parseBoolFromString(
              sessionStorage.getItem('qb_customers')
            ),
            invoices: parseBoolFromString(
              sessionStorage.getItem('qb_invoices')
            ),
          };
          console.log(sessionStorage.getItem('qb_customers'));
          axios
            .get(
              `https://us-central1-kali-45420.cloudfunctions.net/getQBToken`,
              {
                // axios.get(`http://localhost:5000/kali-45420/us-central1/getQBToken`, {
                params: {
                  sendParams,
                },
              }
            )
            .then((response) => {
              console.log(response);
              Swal.fire(
                'Success!',
                'QuickBooks Online account successfully integrated.',
                'success'
              );
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                'Error!',
                'Error setting up Sage Integration.',
                'error'
              );
            });
        }
      }
    },
    updateSageDetails: function() {
      //update the state and the db.
      firebase
        .firestore()
        .collection('organizations')
        .doc(sessionStorage.getItem('org'))
        .collection('integrations')
        .get()
        .then((querySnapshot) => {
          let id;
          querySnapshot.forEach((doc) => {
            //update the doc if it is the sage integration.
            id = doc.id;
          });
          return id;
        })
        .then((id) => {
          //update the document.
          firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('integrations')
            .doc(id)
            .update({
              sage: {
                active: true,
                invoicing: this.sageIntegrationSetup.invoices,
                customers: this.sageIntegrationSetup.customers,
                inventory: this.sageIntegrationSetup.inventory,
                access_token: sessionStorage.getItem('sage_access_token'),
                refresh_token: sessionStorage.getItem('sage_refresh_token'),
              },
            })
            .then(() => {
              try {
                //update the sage integration details.
                this.updateSageStatus({
                  sageStatus: {
                    active: true,
                    invoicing: this.sageIntegrationSetup.invoices,
                    customers: this.sageIntegrationSetup.customers,
                    inventory: this.sageIntegrationSetup.inventory,
                  },
                });
                Swal.fire(
                  'Success!',
                  'Sage integration successfully configured.',
                  'success'
                );
                this.$refs['sage_integration_modal'].hide();
              } catch (err) {
                console.log(err);
                Swal.fire(
                  'Error!',
                  'Error configuring Sage integration.',
                  'error'
                );
              }
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                'Error!',
                'Error configuring Sage integration.',
                'error'
              );
            });
        })
        .catch((err) => {
          console.log(err);
          Swal.fire('Error!', 'Error configuring Sage integration.', 'error');
        });
    },
    updateQBDetails: function() {
      //update the state and the db.
      firebase
        .firestore()
        .collection('organizations')
        .doc(sessionStorage.getItem('org'))
        .collection('integrations')
        .get()
        .then((querySnapshot) => {
          let id;
          querySnapshot.forEach((doc) => {
            //update the doc if it is the sage integration.
            id = doc.id;
          });
          return id;
        })
        .then((id) => {
          //update the document.
          firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('integrations')
            .doc(id)
            .update({
              quick_books: {
                active: true,
                invoicing: this.qbIntegrationSetup.invoices,
                customers: this.qbIntegrationSetup.customers,
                realmId: sessionStorage.getItem('qb_realmId'),
                access_token: sessionStorage.getItem('qb_access_token'),
                refresh_token: sessionStorage.getItem('qb_refresh_token'),
                defaultAccount: {
                  name:
                    this.qbIntegrationSetup.defaultAccount.name != undefined
                      ? this.qbIntegrationSetup.defaultAccount.name
                      : '',
                  id:
                    this.qbIntegrationSetup.defaultAccount.id != undefined
                      ? this.qbIntegrationSetup.defaultAccount.id
                      : '',
                  sync_token:
                    this.qbIntegrationSetup.defaultAccount.sync_token !=
                    undefined
                      ? this.qbIntegrationSetup.defaultAccount.sync_token
                      : '',
                },
              },
            })
            .then(() => {
              try {
                //update the sage integration details.
                this.updateQBStatus({
                  qbStatus: {
                    active: true,
                    invoicing: this.qbIntegrationSetup.invoices,
                    customers: this.qbIntegrationSetup.customers,
                    defaultAccount: {
                      name: this.qbIntegrationSetup.defaultAccount.name,
                      id: this.qbIntegrationSetup.defaultAccount.id,
                      sync_token: this.qbIntegrationSetup.defaultAccount
                        .sync_token,
                    },
                  },
                });
                this.switch_qbIntegration = true;
                Swal.fire(
                  'Success!',
                  'QuickBooks Online integration successfully configured.',
                  'success'
                );
                this.$refs['qbo_integration_modal'].hide();
              } catch (err) {
                console.log(err);
                Swal.fire(
                  'Error!',
                  'Error configuring QuickBooks Onlnie integration.',
                  'error'
                );
              }
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                'Error!',
                'Error configuring QuickBooks Online integration.',
                'error'
              );
            });
        })
        .catch((err) => {
          console.log(err);
          Swal.fire(
            'Error!',
            'Error configuring QuickBooks Online integration.',
            'error'
          );
        });
    },
    sageIntegrationSubmit: function() {
      // check to see if our sage token are undefined. If they are, send the user to get new tokens.
      if (
        sessionStorage.getItem('sage_access_token') == null ||
        sessionStorage.getItem('sage_access_token') == undefined ||
        sessionStorage.getItem('sage_access_token') == 'undefined'
      ) {
        //update the state with the selection, so we will have it stored for when the user returns with new tokens.
        this.updateSageStatus({
          sageStatus: {
            active: true,
            invoicing: this.sageIntegrationSetup.invoices,
            customers: this.sageIntegrationSetup.customers,
            inventory: this.sageIntegrationSetup.inventory,
          },
        });
        //send the user to get a new token.
        window.location.href =
          'https://www.sageone.com/oauth2/auth/central?filter=apiv3.1&client_id=494a145b-97a2-4fb7-ae7b-9315165524f3/6f21ca1b-2e7b-45ae-974f-edde0926f747&redirect_uri=http://localhost:8080/production/admin/settingsContainer&country=ca&locale=en-CA&response_type=code';
      } else {
        //update the token details.
        this.updateSageDetails();
      }
    },
    qbIntegration: function() {
      //before sending off the request to get the uri, set the session variable, so we will know what integration we are setting up when returned from the oauth request.
      sessionStorage.setItem('qb_active', true);
      sessionStorage.setItem('qb_invoicing', this.qbIntegrationSetup.invoices);
      sessionStorage.setItem('qb_customers', this.qbIntegrationSetup.customers);

      axios
        .get(
          `https://us-central1-kali-45420.cloudfunctions.net/getQBAuthCode`,
          {
            //axios.get(`http://localhost:5000/kali-45420/us-central1/getQBAuthCode`, {
          }
        )
        .then((response) => {
          //redirect the user to the OAuth uri.
          window.location.href = response.data.uri;
        })
        .catch((err) => {
          console.log(err);
          Swal.fire('Error!', 'Error setting up Sage Integration.', 'error');
        });
    },
    qboIntegrationSubmit: function() {
      // check to see if our sage token are undefined. If they are, send the user to get new tokens.
      if (
        sessionStorage.getItem('qb_access_token') == null ||
        sessionStorage.getItem('qb_access_token') == undefined ||
        sessionStorage.getItem('qb_access_token') == 'undefined' ||
        sessionStorage.getItem('qb_access_token') == ''
      ) {
        //update the state with the selection, so we will have it stored for when the user returns with new tokens.
        this.updateQBStatus({
          qbStatus: {
            active: true,
            invoicing: this.sageIntegrationSetup.invoices,
            customers: this.sageIntegrationSetup.customers,
          },
        });
        //send the user to get new tokens.
        this.qbIntegration();
      } else {
        //update the token details.
        console.log('the other place');
        this.updateQBDetails();
      }
    },
    disableIntegration: function(integration) {
      //set the integration to being inactive and update the sesstion storage.
      firebase
        .firestore()
        .collection('organizations')
        .doc(sessionStorage.getItem('org'))
        .collection('integrations')
        .get()
        .then(async (querySnapshot) => {
          let id;
          let config;
          querySnapshot.forEach((doc) => {
            //get the whole integration array and set it to a local variable, so we can edit it.
            id = doc.id;
            config = doc.data()[integration];
          });
          config.active = false;
          await firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('integrations')
            .doc(id)
            .update({
              [integration]: config,
            })
            .then(() => {
              this.switch_qbIntegration = false;
              console.log(`Deactivated ${integration} integration`);
            })
            .catch((err) => {
              console.log(`Error updating Sage integration details: ${err}`);
            });
        })
        .catch((err) => {
          console.log(
            `Error getting Sage integration details before updating.: ${err}`
          );
        });
      console.log(integration);
    },
    getQBAccounts: function() {
      this.qbIntegrationSetup.accounts = [];
      getQBIncomeAccounts()
        .then((response) => {
          console.log(response.data.response);
          response.data.response.Item.forEach((account) => {
            this.qbIntegrationSetup.accounts.push({
              name: account.Name,
              id: account.Id,
              sync_token: account.SyncToken,
            });
          });
        })
        .catch((err) => {
          //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
          if (
            err.response.status == 401 &&
            err.response.data.response == 'Token expired'
          ) {
            console.log('token expired');
            //refresh the token.
            let sendParams = {
              refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
              org: sessionStorage.getItem('org'),
              realmId: sessionStorage.getItem('qb_realmId'),
            };

            axios
              .get(
                `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                {
                  // axios.get(`http://localhost:5000/kali-45420/us-central1/refreshQBToken`, {
                  params: {
                    sendParams,
                  },
                }
              )
              .then(async (response) => {
                let success = await updateQBOIntegrationDetails(
                  response.data.response.access_token,
                  response.data.response.refresh_token,
                  sessionStorage.getItem('qb_invoicing'),
                  sessionStorage.getItem('qb_customers'),
                  sessionStorage.getItem('qb_realmId'),
                  sessionStorage.getItem('qb_defaultAccountId'),
                  sessionStorage.getItem('qb_defaultAccountName')
                );
                if (success) {
                  this.getQBAccounts();
                } else {
                  console.log('error updating QuickBooks integration details.');
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.log(err);
            console.log(`Error getting the QuickBooks income accounts`);
            Swal.fire(
              'Error!',
              'Error getting the QuickBooks income accounts.',
              'error'
            );
          }
        });
    },
    getSettings: function() {
      return firebase
      .firestore()
      .collection('organizations')
      .doc(sessionStorage.getItem('org'))
      .collection('settings')
      .get()
      .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            let orgSettings = doc.data();
            orgSettings['docID'] = doc.id;
            // add work_orders to the settings if it doesn't exist
            if(!orgSettings['work_orders']){
              orgSettings['work_orders'] = {};
            } 
            this.orgSettings = orgSettings;
            this.settingsDocId = doc.id;
            if(doc.data().work_orders) {
              this.switch_newIssueEmailSetting = doc.data().work_orders.newIssueEmailEnabled ? doc.data().work_orders.newIssueEmailEnabled : false;
              this.switch_workOrderRequestedChangesSetting = doc.data().work_orders.requestedChangesNotificationEmailEnabled ? doc.data().work_orders.requestedChangesNotificationEmailEnabled : false;
              this.selectedNewIssueNotiEmailOption = this.newIssueNotiEmailOptions.find(
                  option => option.option === doc.data().work_orders.newIssueNotificationEmailOption
                ) || (this.selectedNewIssueNotiEmailOption = {option: 'All Mechanic Users', index: 0});
              this.selectedRequestedChangesNotiEmailOption = this.requestedChangesNotiEmailOptions.find(
                  option => option.option === doc.data().work_orders.requestedChangesNotificationEmailOption
                ) || (this.selectedRequestedChangesNotiEmailOption = {option: 'Employee that Submitted the Work Order', index: 0});
              this.switch_workOrderApprovalEmailSetting = doc.data().work_orders.submittedForApprovalEmailEnabled ? doc.data().work_orders.submittedForApprovalEmailEnabled : false; 
              this.workOrderPageSettings.newIssueNotificationEmails = doc.data().work_orders.newIssueNotificationEmails ? doc.data().work_orders.newIssueNotificationEmails : [];
              this.workOrderPageSettings.requestedChangesNotificationEmails = doc.data().work_orders.requestedChangesNotificationEmails ? doc.data().work_orders.requestedChangesNotificationEmails : [];
              this.workOrderPageSettings.submittedForApprovalNotificationEmails = doc.data().work_orders.submittedForApprovalNotificationEmails ? doc.data().work_orders.submittedForApprovalNotificationEmails : [];

              if(doc.data().work_orders.newIssueNotificationUserTypes){
                if(doc.data().work_orders.newIssueNotificationUserTypes.length > 0){
                  let selectedOptions = [];
                  doc.data().work_orders.newIssueNotificationUserTypes.forEach((userType)=>{
                    const option = this.newIssueNotiUserTypeOptions.find(x => x.option === userType);
                    if(option){
                      selectedOptions.push(option);
                    }
                  });

                  this.selectedNewIssueNotiUserTypeOption = selectedOptions;
                }
              }
            }
        })
      })
    },
    UpdateWorkOrderPageSettings: function() {
      this.loadingWorkOrderPageSettingsUpdate = true;
      if (this.orgSettings) { 
        // update the orgSettings
        let copyOrgWorkOrderSettings = lodash.cloneDeep(this.orgSettings.work_orders);
        copyOrgWorkOrderSettings['requestedChangesNotificationEmailEnabled'] = this.switch_workOrderRequestedChangesSetting;
        copyOrgWorkOrderSettings['submittedForApprovalEmailEnabled'] = this.switch_workOrderApprovalEmailSetting;
        copyOrgWorkOrderSettings['requestedChangesNotificationEmailOption'] = this.selectedRequestedChangesNotiEmailOption.option;
        copyOrgWorkOrderSettings['newIssueEmailEnabled'] = this.switch_newIssueEmailSetting;
        copyOrgWorkOrderSettings['newIssueNotificationEmails'] = this.workOrderPageSettings.newIssueNotificationEmails;
        copyOrgWorkOrderSettings['newIssueNotificationUserTypes'] = [];
        copyOrgWorkOrderSettings['newIssueNotificationEmailOption'] = this.selectedNewIssueNotiEmailOption.option;
        copyOrgWorkOrderSettings['requestedChangesNotificationEmails'] = this.workOrderPageSettings.requestedChangesNotificationEmails;
        copyOrgWorkOrderSettings['submittedForApprovalNotificationEmails'] = this.workOrderPageSettings.submittedForApprovalNotificationEmails;
        // the new issue user type setting is a multi select so push the selected options to the array
        this.selectedNewIssueNotiUserTypeOption.forEach((selection)=>{
          copyOrgWorkOrderSettings['newIssueNotificationUserTypes'].push(selection.option);
        });

        // check that all entered emails are valid
        this.workOrderPageSettings.newIssueNotificationEmails.forEach((email, index) => {
          this.validateNotificationEmail(email, 'newIssueNotificationEmailErrorMessage', index);
        });
        this.workOrderPageSettings.requestedChangesNotificationEmails.forEach((email, index) => {
          this.validateNotificationEmail(email, 'requestedChangesNotificationEmailErrorMessage', index);
        });
        this.workOrderPageSettings.submittedForApprovalNotificationEmails.forEach((email, index) => {
          this.validateNotificationEmail(email, 'submittedForApprovalNotificationEmailErrorMessage', index);
        });

        if(this.workOrderPageSettingsErrors.newIssueNotificationEmailErrorMessage.length === 0 &&
          this.workOrderPageSettingsErrors.requestedChangesNotificationEmailErrorMessage.length === 0 &&
          this.workOrderPageSettingsErrors.submittedForApprovalNotificationEmailErrorMessage.length === 0
        ) {
          if((this.workOrderPageSettings.newIssueNotificationEmails.length === 0 && this.switch_newIssueEmailSetting && this.selectedNewIssueNotiEmailOption.option === 'Custom Email(s)') ||
            (this.workOrderPageSettings.requestedChangesNotificationEmails.length === 0 && this.switch_workOrderRequestedChangesSetting && this.selectedRequestedChangesNotiEmailOption.option === 'Custom Email(s)') ||
            (this.workOrderPageSettings.submittedForApprovalNotificationEmails.length === 0 && this.switch_workOrderApprovalEmailSetting)
          ){
            Vue.$toast.open({
              message: 'If a notification email setting is enabled, at least one email must be entered.',
              type: 'error',
              duration: 14000,
              position: 'top-right',
            });
            this.loadingWorkOrderPageSettingsUpdate = false;
          } 
          else if(this.switch_newIssueEmailSetting && this.selectedNewIssueNotiUserTypeOption.length === 0){
            Vue.$toast.open({
              message: 'If the New Issue Submitted notification is enabled, you must select a User Type.',
              type: 'error',
              duration: 14000,
              position: 'top-right',
            });
            this.loadingWorkOrderPageSettingsUpdate = false;
          } 
          else{
            try{
              firebase
                .firestore()
                .collection('organizations')
                .doc(sessionStorage.getItem('org'))
                .collection('settings')
                .doc(this.orgSettings.docID) 
                .update({
                  'work_orders': copyOrgWorkOrderSettings
                })
                .then(() => {
                  this.orgSettings.work_orders = copyOrgWorkOrderSettings;
                  Swal.fire(
                          'Success!',
                          'Work Order settings updated successfully.',
                          'success'
                        );
                  this.loadingWorkOrderPageSettingsUpdate = false;
                })
                .catch((error) => {
                  console.error('Error updating the Work Order settings:', error);
                  Swal.fire(
                          'Error!',
                          `Error updating the Work Order settings`,
                          'error'
                        );
                  this.loadingWorkOrderPageSettingsUpdate = false;
                });
            } catch(err){
              console.error('Error updating the Work Order settings in the database:', err);
              Swal.fire(
                      'Error!',
                      `Error updating the Work Order settings in the database`,
                      'error'
                    );
              this.loadingWorkOrderPageSettingsUpdate = false;
            }
          }
        } else{
          this.loadingWorkOrderPageSettingsUpdate = false;
        }
      }else{
        this.loadingWorkOrderPageSettingsUpdate = false;
      }
    },
    validateNotificationEmail: function(email, setting, emailIndex) {
      //make sure the email isn't empty and is a valid format.
      if (!validateEmail(email.trim())) {
        // add the error message if it doesn't exist
        const errorIndex = this.workOrderPageSettingsErrors[`${setting}`].findIndex((x) => x.index === emailIndex);
        if (errorIndex === -1) {
          this.workOrderPageSettingsErrors[`${setting}`].push({
            index: emailIndex,
            message: 'Invalid Format.',
          }); 
        }
      } else {
        // remove the error message if it exists
        const errorIndex = this.workOrderPageSettingsErrors[`${setting}`].findIndex((x) => x.index === emailIndex);
        if (errorIndex > -1) {
          this.workOrderPageSettingsErrors[`${setting}`].splice(errorIndex, 1);
        }
      }
    },
    handleAddNotificationEmailInput: function (setting) {
      // make copy of array of notification emails and add new input to it
      let notiEmailsCopy = lodash.cloneDeep(this.workOrderPageSettings[`${setting}`]);
      notiEmailsCopy.push('');
      this.workOrderPageSettings[`${setting}`] = notiEmailsCopy;
    },
    handleRemoveNotificationEmailInput: function (setting, index, errorSetting) {
      // make copy of array of notification emails and remove input from it
      let notiEmailsCopy = lodash.cloneDeep(this.workOrderPageSettings[`${setting}`]);
      notiEmailsCopy.splice(index, 1);
      this.workOrderPageSettings[`${setting}`] = notiEmailsCopy;

      // check if the removed email had an error message and remove it
      let workOrderPageSettingsErrorsCopy = lodash.cloneDeep(this.workOrderPageSettingsErrors[`${errorSetting}`]);
      const errorIndex = workOrderPageSettingsErrorsCopy.findIndex((x) => x.index === index);
      if(errorIndex > -1) {
        workOrderPageSettingsErrorsCopy.splice(errorIndex, 1);
      }

      // remove any error messages that have an index greater than the length of the noti emails array
      workOrderPageSettingsErrorsCopy.forEach((error, errorMessageIndex) => {
        if(error.index + 1 > this.workOrderPageSettings[`${setting}`].length) {
          workOrderPageSettingsErrorsCopy.splice(errorMessageIndex, 1);
        }
      });
      this.workOrderPageSettingsErrors[`${errorSetting}`] = workOrderPageSettingsErrorsCopy;

      // go over emails and re-validate them again so the error message indexes are re-sorted
      this.workOrderPageSettings[`${setting}`].forEach((email, emailIndex) => {
          this.validateNotificationEmail(email, errorSetting, emailIndex);
        });
    },
    async getUserPositionTypes(){
      try{
        const positionsSnapShot = await getPositions();

        positionsSnapShot.docs.forEach((doc, index)=>{
          this.newIssueNotiUserTypeOptions.push({option: doc.data().name, index: index + 1});
        });
      } catch(err){
        console.log('Error retrieving the user position types: ', err);
        Swal.fire(
          'Error!',
          `Error retrieving the user position types`,
          'error'
        );
      }
    },
    handleNewIssueNotiUserTypeSelection(selectedOptions){
      if(selectedOptions.length > this.previouslySelectedNotiUserTypeOption.length){
        // find which option is newly selected
        const previousOptionsSet = new Set(this.previouslySelectedNotiUserTypeOption.map(x => x.option));
        const newlySelectedOption = selectedOptions.find(option => !previousOptionsSet.has(option.option));

        // if the user selected All remove any other selected options
        if(newlySelectedOption.option === 'All User Types'){
          // update the previous array
          this.previouslySelectedNotiUserTypeOption = [{option: 'All User Types', index: 0}];

          this.selectedNewIssueNotiUserTypeOption = [{option: 'All User Types', index: 0}];
        } else if(selectedOptions.find(x => x.option === 'All User Types')){
          // all option is selected but a new option has been selected so deselect the all option
          let selectedOptionsCopy = lodash.cloneDeep(selectedOptions);

          const selectedOptionIndex = selectedOptionsCopy.findIndex(x => x.option === 'All User Types');
          selectedOptionsCopy.splice(selectedOptionIndex, 1);

          // update the previous array
          this.previouslySelectedNotiUserTypeOption = selectedOptionsCopy;

          this.selectedNewIssueNotiUserTypeOption = selectedOptionsCopy;
        } else{
          // just update the previous array
          this.previouslySelectedNotiUserTypeOption = selectedOptions;
        }
      } else{
        // find which option was removed
        const selectedOptionsSet = new Set(selectedOptions.map(x => x.option));
        const removedOption = this.previouslySelectedNotiUserTypeOption.find(option => !selectedOptionsSet.has(option.option));

        // update previous array
        this.previouslySelectedNotiUserTypeOption = this.previouslySelectedNotiUserTypeOption.filter(option => option.option !== removedOption.option);
      }
    }
  },
  computed: {
    integrationsAuthorized: function() {
      // console.table([
      //   sessionStorage.getItem('qb_authorized'),
      //   sessionStorage.getItem('sage_authorized'),
      //   sessionStorage.getItem('tikker_authorized'),
      // ]);

      return {
        quick_books: sessionStorage.getItem('qb_authorized'),
        sage: sessionStorage.getItem('sage_authorized'),
        tikker: sessionStorage.getItem('tikker_authorized'),
      };
    },
  },
  created: async function() {
    this.getBillingInfo();
    await this.getUserPositionTypes();
    this.getSettings();
    if (sessionStorage.getItem('sage_active') == 'true') {
      this.switch_sageIntegration = true;
      this.sageIntegrationSetup.invoices = parseBoolFromString(
        sessionStorage.getItem('sage_invoicing')
      );
      this.sageIntegrationSetup.customers = parseBoolFromString(
        sessionStorage.getItem('sage_customers')
      );
      this.sageIntegrationSetup.inventory = parseBoolFromString(
        sessionStorage.getItem('sage_inventory')
      );
    }
    if (sessionStorage.getItem('qb_active') == 'true') {
      this.switch_qbIntegration = true;
      this.qbIntegrationSetup.invoices = parseBoolFromString(
        sessionStorage.getItem('qb_invoicing')
      );
      this.qbIntegrationSetup.customers = parseBoolFromString(
        sessionStorage.getItem('qb_customers')
      );
      this.qbIntegrationSetup.defaultAccount.id = sessionStorage.getItem(
        'qb_defaultAccountId'
      );
      this.qbIntegrationSetup.defaultAccount.name = sessionStorage.getItem(
        'qb_defaultAccountName'
      );
      this.getQBAccounts();
    }

    this.checkOAuthQueryString();
  },
};
</script>

<style lang="scss">
.addEmailInput {
  color: #556ee6;
  i {
    font-size: 1rem;
    padding-top: 0.08rem;
  }
  i:hover,
  p:hover {
    cursor: pointer;
  }
}

.removeEmailInput {
  color: #556ee6;
  i {
    font-size: 1rem;
    padding-top: 0.08rem;
  }
  i:hover,
  p:hover {
    cursor: pointer;
  }
}

.user-type-select{
  .vs__dropdown-toggle {
    min-height: calc(1.5em + 0.94rem + 2px) !important;
    height: auto !important;
  }
}
</style>
